import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { MARKETS } from "../lib/currency";

export const MarketSelector = ({ market, onChange, dark = false, reassure = true }) => {
  const labelCls = dark ? "text-cream/70" : "text-ink/60";
  const triggerCls = dark
    ? "w-[260px] bg-cream/10 border-cream/25 text-cream hover:bg-cream/15 focus:ring-ochre/40"
    : "w-[260px] bg-cream border-line text-ink hover:bg-ivory focus:ring-clay/30";
  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center gap-3">
        <span className={`text-sm font-medium ${labelCls}`}>Pricing for</span>
        <Select value={market} onValueChange={onChange}>
          <SelectTrigger data-testid="market-selector" className={`${triggerCls} rounded-full h-10 px-4 text-sm font-semibold`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="max-h-[340px]">
            {MARKETS.map((m) => (
              <SelectItem key={m.code} value={m.code} data-testid={`market-${m.code}`}>
                <span className="flex flex-col">
                  <span>{m.label}</span>
                  {m.sub && <span className="text-[11px] text-muted-foreground leading-tight">{m.sub}</span>}
                </span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <p className={`mt-2.5 text-xs ${dark ? "text-cream/50" : "text-muted-foreground"}`}>
        Prices are adjusted by market.{reassure ? " Secure payment options available at checkout." : ""}
      </p>
    </div>
  );
};
